import PropTypes from 'prop-types';
import TrainerInfoItem from './TrainerInfoItem';
import TrainerInfoLanguage from './TrainerInfoLanguage';

const defaultProps = {};

const propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function TrainerInfoLanguages({ languages }) {
  return (
    <TrainerInfoItem label="Idiomas">
      <div className="flex items-center space-x-1">
        {languages.map((lang) => (
          <TrainerInfoLanguage key={lang} lang={lang} />
        ))}
      </div>
    </TrainerInfoItem>
  );
}

TrainerInfoLanguages.defaultProps = defaultProps;
TrainerInfoLanguages.propTypes = propTypes;
